/**
 * @typedef {import('../../../interfaces/AUI/IDropdownButton.interface').IDropdownButtonItem} IDropdownButtonItem
 */

import React from 'react';
import { format } from 'date-fns';
import AUIBadge from '@ancert/aui-badge';
import { AUIDropdownButtonCell, AUIButtonCell } from '@ancert/aui-table-cell';
import AUIEllipsis from '@ancert/aui-ellipsis';

import { ESTADOS_DENUNCIA } from '../../../lib/denuncia.enum';

/**
 * @typedef {object} events
 * @property {Function} onRowVer
 * @property {Function} onRowAsignar
 */

/**
 * @param {events} events
 * @param {object} row
 * @returns {Array<IDropdownButtonItem>}
 */
const getItems = ({ onRowVer, onRowAsignar }, row) => [
  { label: 'Ver', command: () => onRowVer(row.complaint.publicId) },
  { label: 'Asignar denuncia', command: () => onRowAsignar(row.complaint.id) },
];

/**
 * @param {events} events
 * @param {boolean} canEdit
 * @param {boolean} canViewId
 * @returns
 */
const getColumns = (events, canEdit, canViewId) => [
  {
    id: 'icon',
    accessor: (row) => row.complaint.pendingCounter,
    columnWidth: 48,
    header: '',
    cell: ({ value }) => <AUIBadge content={value || 0} color={value > 0 ? 'red' : 'grey'} />,
  },
  {
    id: 'id',
    accessor: (row) => row.complaint,
    columnWidth: canViewId ? 80 : 280,
    header: 'ID',
    cell: ({ value }) => <>{canViewId ? value.id : value.publicId}</>,
  },
  {
    id: 'denunciante',
    accessor: (row) => row.user,
    header: 'Denunciante',
    cell: ({ value }) => {
      const { name, lastname1, lastname2 } = value;
      let fullName = 'Anónimo';
      if (name) {
        fullName = `${name} ${lastname1}${lastname2 ? ` ${lastname2}` : ''}`;
      }
      return <AUIEllipsis content={fullName} />;
    },
  },
  {
    id: 'email',
    accessor: (row) => row.user.email,
    columnWidth: 260,
    header: 'Correo electrónico',
    cell: ({ value }) => <AUIEllipsis content={value ?? ''}/>,
  },
  {
    id: 'documentType',
    accessor: (row) => row.user.documentType,
    columnWidth: 120,
    header: 'Tipo documento',
    cell: ({ value }) => <AUIEllipsis content={value ?? ''}/>,
  },
  {
    id: 'dni',
    accessor: (row) => row.user.document,
    columnWidth: 100,
    header: 'Doc. identidad',
    cell: ({ value }) => <>{!value ? '' : value}</>,
  },
  {
    id: 'fecha',
    accessor: (row) => row.complaint.creationDate,
    header: 'Fecha',
    columnWidth: 100,
    cell: ({ value }) => <>{format(new Date(value), 'dd/MM/yyyy')}</>,
  },
  {
    id: 'status',
    accessor: (row) => row.complaint.status,
    header: 'Estado',
    columnWidth: 96,
    cell: ({ value }) => <>{ESTADOS_DENUNCIA[value].desc}</>,
  },
  {
    id: 'action',
    accessor: (row) => row,
    columnWidth: 48,
    header: '',
    cell: ({ value }) => {
      if (canEdit) {
        return <AUIDropdownButtonCell items={getItems(events, value)} />;
      }
      const { onRowVer } = events;
      return (
        <AUIButtonCell
          buttonList={[
            {
              mode: 'ghost',
              label: 'Ver',
              onClick: () => onRowVer(value.complaint.publicId),
            },
          ]}
        />
      );
    },
  },
];

export default getColumns;
